import { Reveal, SectionHead } from "./Reveal";

const STEPS = [
    {
        n: "01",
        title: "Give Us a Call",
        text: "Tell us what happened and where you need service.",
    },
    {
        n: "02",
        title: "Get Clear Information",
        text: "We'll discuss the service you need and what to expect.",
    },
    {
        n: "03",
        title: "We Come to You",
        text: "A professional locksmith comes to your location with the appropriate tools and equipment.",
    },
    {
        n: "04",
        title: "Get Back to Your Day",
        text: "We'll complete the necessary locksmith work and help restore your access or security.",
    },
];

export const HowItWorks = () => (
    <section id="how-it-works" data-testid="how-it-works-section" className="bg-slate-50 py-20 sm:py-24 lg:py-28">
        <div className="mx-auto w-full max-w-7xl px-5 sm:px-8">
            <SectionHead eyebrow="Simple Process" title="How It Works" testId="how-it-works-heading" />
            <div className="mt-14 grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
                {STEPS.map((s, i) => (
                    <Reveal key={s.n} delay={i * 0.1}>
                        <div data-testid={`how-it-works-step-${i + 1}`} className="relative border-t-2 border-navy-950/10 pt-6">
                            <span className="font-display text-5xl font-semibold italic text-gold/80">{s.n}</span>
                            <h3 className="mt-4 font-display text-xl font-semibold text-slate-900">{s.title}</h3>
                            <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.text}</p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
